import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PageTitle from "shared/ui/PageTitle";
import BoxContent from "shared/ui/BoxContent";
import LinkStyled from "shared/ui/LinkStyled";

const CONTACT_INFO = [
    {
        label: 'E-mail',
        value: <a href="mailto:office@brio.ro">office@brio.ro</a>
    },
    {
        label: 'Telefon',
        value: <><a href="tel:+40751237170">0751.237.170</a> (L-V, 10:00-17:00)</>
    },
    {
        label: 'Adresa',
        value: 'Str. Icoanei nr. 29A, București, Sector 2, Cod poștal 020452, România'
    }
];

const ContactField = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <>
        <Grid item xs={12} sm={3} md={2}>
            <Typography variant="body1"><b>{label}:</b></Typography>
        </Grid>
        <Grid item xs={12} sm={9} md={10}>
            <Typography variant="body1">{children}</Typography>
        </Grid>
    </>
);

const Contact = ({layoutPublic = false} : {layoutPublic?: boolean}) => {

    const description = (
        <Typography variant="h3" mb={1.6}>
            Dacă ați întâmpinat dificultăți în folosirea platformei și nu ați găsit răspunsul în secțiunea{' '}
            <LinkStyled to="/intrebari-frecvente">Întrebări frecvente</LinkStyled> sau în instrucțiunile video din{' '}
            <LinkStyled to="/tutoriale">Tutoriale</LinkStyled>, ne puteți contacta folosind:
        </Typography>
    );

    return (
        <Box component="main">
            <PageTitle>Contact</PageTitle>
            {!layoutPublic && description}
            <BoxContent>
                <Grid container spacing={1.5} alignItems="center">
                    {CONTACT_INFO.map((item) => (
                        <ContactField key={item.label} label={item.label}>
                            {item.value}
                        </ContactField>
                    ))}
                </Grid>
            </BoxContent>
        </Box>
    )
}

export default Contact;